'use es6';

import { List } from 'immutable';
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import LegalConsentOptions from 'MeetingsBase/models/LegalConsentOptions';
import LegalConsentFields from 'FormsCommonComponents/LegalConsentFields';
import LegalConsent from 'FormsCommonComponents/lib/LegalConsent';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { jsx as _jsx } from "react/jsx-runtime";
const LegalConsentInputs = ({
  legalConsentOptions,
  legalConsentResponses,
  setGivenConsent
}) => {
  const previewModel = new LegalConsent(legalConsentOptions.convertToJSON());
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(Tile, {
      size: "small",
      backgroundColor: "fill-surface-recessed",
      children: /*#__PURE__*/_jsx(TileSection, {
        overflowWrap: "break-word",
        paddingBlockEnd: "0",
        children: /*#__PURE__*/_jsx(LegalConsentFields, {
          legalConsentRecord: previewModel,
          legalConsentResponses: legalConsentResponses,
          onCommunicationCheckboxChange: setGivenConsent
        })
      })
    })
  });
};
LegalConsentInputs.propTypes = {
  legalConsentOptions: PropTypes.instanceOf(LegalConsentOptions).isRequired,
  legalConsentResponses: PropTypes.instanceOf(List),
  setGivenConsent: PropTypes.func.isRequired
};
export default LegalConsentInputs;